// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"357":"dbbcceb6d40530f5","488":"2d2b3caf27d9deef","917":"5ba020f2e3354b4c","971":"7ae5b61fa9ac920f"}[chunkId] + ".js";
};